import React, { useEffect, useState } from "react";
import axiosInstance, { handleApiError } from "../../services/axiosService";
import { toastSuccess } from "../../utils/toastUtils";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";

const TokenManager = () => {
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(false);

  const generateToken = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(`/generate-custom-token`);
      const newToken = response?.data;
      setToken(newToken);
      toastSuccess("New token generated!");
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  const getToken = async () => {
    try {
      const response = await axiosInstance.get(`/generate-custom-token`);
      const existingToken = response?.data;
      if (existingToken) setToken(existingToken);
    } catch (error) {
      console.error("No token found");
      // handleApiError(error);
    }
  };

  useEffect(() => {
    getToken();
  }, []);

  const copyToken = async () => {
    if (token) {
      await navigator.clipboard.writeText(token);
      toastSuccess("Token copied to clipboard!");
    }
  };

  return (
    <div
      className="d_flex align_center gap_2 text_white w_100"
      // onClick={generateToken}
      aria-disabled={loading}
      style={{ cursor: loading ? "not-allowed" : "pointer" }}
    >
      <MaterialIcon name="vpn_key" style={{ fontSize: "20px" }} />

      {token ? (
        <div className="d_flex align_center py_2 gap_2 w_100 justify_between action_names">
          <span
            style={{
              display: "inline-block",
              maxWidth: "60px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              verticalAlign: "bottom"
            }}
          >
            {token}
          </span>
          {loading ? (
            <span
              style={{
                width: "16px",
                height: "16px",
                border: "2px solid #fff",
                borderTop: "2px solid transparent",
                borderRadius: "50%",
                display: "inline-block",
                animation: "spin 1s linear infinite"
              }}
            />
          ) : (
            <div className="d_flex align_center gap_2">
              <MaterialIcon
                onClick={copyToken}
                name="content_copy"
                className="cursor_pointer"
                style={{ fontSize: "20px", background: "transparent" }}
              />
              <MaterialIcon name="autorenew" style={{ fontSize: "20px" }} onClick={generateToken} />
            </div>
          )}
        </div>
      ) : (
        <div className="d_flex align_center py_2 gap_2">
          <span className="font_size_medium action_names">No Token Available</span>
          <button
            onClick={generateToken}
            disabled={loading}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              color: "#fff",
              border: "none",
              borderRadius: "12px",
              cursor: loading ? "not-allowed" : "pointer",
              opacity: loading ? 0.7 : 1,
              background: "transparent"
            }}
          >
            {loading ? (
              <span
                style={{
                  width: "16px",
                  height: "16px",
                  border: "2px solid #fff",
                  borderTop: "2px solid transparent",
                  borderRadius: "50%",
                  display: "inline-block",
                  animation: "spin 1s linear infinite"
                }}
              />
            ) : (
              <MaterialIcon name="autorenew" style={{ fontSize: "20px" }} />
            )}
          </button>
        </div>
      )}
    </div>
  );
};

export default TokenManager;
